import { EProviderAccountType, schemes, zSchema } from "@zeal/common";

export const createCompanyAccountRequestSchema = zSchema.object({
  account_type: zSchema.nativeEnum(EProviderAccountType),
  odoUserId: schemes.mongoOrUuid(),
  perform_kyc: zSchema.boolean().default(false),
});

export type TCreateCompanyAccountRequestSchema = zSchema.infer<
  typeof createCompanyAccountRequestSchema
>;

export const createCompanyAccountResponseSchema = zSchema.object({
  company_balance_account_app_id: zSchema.string().optional(),
  company_balance_account_id: zSchema.string().optional(),
  custody_account_app_id: zSchema.string().optional(),
  custody_account_id: zSchema.string().optional(),
  deductions_account_app_id: zSchema.string().optional(),
  deductions_account_id: zSchema.string().optional(),
  faster_pay_reserve_account_app_id: zSchema.string().optional(),
  faster_pay_reserve_account_id: zSchema.string().optional(),
  odo_user_id: schemes.mongoOrUuid(),
  reserve_account_app_id: zSchema.string().optional(),
  reserve_account_id: zSchema.string().optional(),
  tax_account_app_id: zSchema.string().optional(),
  tax_account_id: zSchema.string().optional(),
  zeal_id: schemes.uuid(),
});

export type TCreateCompanyAccountResponseSchema = zSchema.infer<
  typeof createCompanyAccountResponseSchema
>;
